// extracted by mini-css-extract-plugin
module.exports = {"dimmable--active":"Dimmable_dimmable--active__-4-gE","dimmable-promoted":"Dimmable_dimmable-promoted__3lxbL","dimmable-overlay":"Dimmable_dimmable-overlay__fvStv"};